// components
import AccrualsListRows from './AccrualsListRows'

// styles
import '../project/Project.css'

// store
import { projectStore } from '../../store/Store'

export default function AccrualsList() {
  // global
  const projectAccruals = projectStore(data => data.projectAccruals)
  
  return (projectAccruals) ? (
    <div className='container-fluid'>
      <div className='row g-2'>
        <div className='load-display-list'>
          <table className='table table-sm table-hover'>
            <thead>
              <tr>
                <th>Name</th>
                <th>Start</th>
                <th>End</th>
                <th>Loads</th>
                <th>Freight Weight (tons)</th>
                <th>Freight Weight Not Billed</th>
                <th>Freight Weight Not Received</th>
                <th>Sand Weight (tons)</th>
                <th>Sand Weight Not Billed</th>
                <th>Sand Weight Not Received</th>
                <th>Freight Rev</th>
                <th>Freight Not Billed</th>
                <th>Freight Cost</th>
                <th>Freight Not Received</th>
                <th>Sand Rev</th>
                <th>Sand Not Billed</th>
                <th>Sand Cost</th>
                <th>Sand Not Received</th>
                <th>Action</th>
              </tr>
            </thead>
            <AccrualsListRows/>
          </table>
        </div>
      </div>
    </div>
  ) : (
    <div>No Accruals have been generated yet</div>
  )
}
